<template>
    <el-dialog custom-class="pharmacy-drugs-dialog" title="药品详情" :visible.sync="dialogVisible">
        <el-form label-suffix="：" ref="form" :model="detailInfo" label-width="100px">
            <el-form-item label="药品名称">
                <el-input v-model="detailInfo.drugName" disabled></el-input>
            </el-form-item>
            <el-form-item label="药品类型">
                <el-select v-model="detailInfo.drugType" placeholder="请选择" disabled>
                    <el-option label="西药" value="WESTERN_MEDICINE"></el-option>
                    <el-option label="中成药" value="PATENT_MEDICINE"></el-option>
                    <el-option label="草药" value="HERBAL_MEDICINE"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="药品编号">
                <el-input v-model="detailInfo.drugCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="药品英文名">
                <el-input v-model="detailInfo.drugEnglishName" disabled></el-input>
            </el-form-item>
            <el-form-item label="药品规格">
                <el-input v-model="detailInfo.drugSpecification" disabled></el-input>
            </el-form-item>
            <el-form-item label="药房单位">
                <el-input v-model="detailInfo.drugUnit" disabled></el-input>
            </el-form-item>
            <el-form-item label="剂量单位">
                <el-input v-model="detailInfo.dosageUnit" disabled></el-input>
            </el-form-item>
            <el-form-item label="用法">
                <el-input v-model="detailInfo.drugAdmission" disabled></el-input>
            </el-form-item>
<!--            <el-form-item label="药品产地">-->
<!--                <el-input v-model="detailInfo.drugOrigin" disabled></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="平台价格">-->
<!--                <el-input v-model="detailInfo.price/100" disabled></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="是否有库存">
                <el-select v-model="detailInfo.isHave" placeholder="请选择">
                    <el-option label="有库存" :value="true"></el-option>
                    <el-option label="暂无库存" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="拼音码">
                <el-input v-model="detailInfo.speedyCodePinyin" disabled></el-input>
            </el-form-item>
            <el-form-item label="五笔码">
                <el-input v-model="detailInfo.speedyCodeWubi" disabled></el-input>
            </el-form-item>
            <el-form-item label="其他码">
                <el-input v-model="detailInfo.speedyCodeOther" disabled></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSave">确定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script lang="es6">
    import {tokenCache} from "../../lib/cache/Token";

    export default {
    props: {
      visible: Boolean,
      drugInfo: Object
    },
    data() {
      return {
        detailInfo: {}
      }
    },
    watch: {
      drugInfo(val) {
        this.detailInfo = Object.assign({}, val);
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit("update:visible", val);
        }
      }
    },
    methods: {
      async onSave() {
        const options = {
            token: tokenCache.get(),
            drugId: this.detailInfo.drugId,
          haveDrug: this.detailInfo.isHave
        }
        const {code, list, page, msg} = await this.$http('smarthos.recipe.hosdrug.save',options)
        if (code === "0") {
          this.$message.success('编辑药品详情成功');
          this.$emit("update:visible", false);
          this.$emit('close')
        } else {
          this.$message.error(msg);
        }
      }
    }
  };
</script>
